module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/scandal.74b973c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/scandal.jpg
// module id = rFSB
// module chunks = 0